class Account {
    constructor() {
		if (document.querySelector("#um_field_general_register_profile_photo")) {
			this.registerProfilePhoto = document.querySelector("#um_field_general_register_profile_photo");
			this.profilePhotoInput = document.querySelector("#register_profile_photo");
			this.accountForm = document.querySelector(".um-account .um-form form");
			this.accountSmallAvatar = document.querySelector(".um-account-meta-img-b a img");

            this.events();
		}
    }

    events() {
		setTimeout(() => { this.loadProfileImage() }, 400);

		// Get the initial value of the input element
		let inputValue = this.profilePhotoInput.getAttribute('value');

		// Create a new MutationObserver
		const observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				// Check if the mutation is a change to the value attribute of the input element
				if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
					// The value attribute has changed

					this.submitChanges();

					// Update the inputValue variable with the new value of the value attribute
					inputValue = this.profilePhotoInput.getAttribute('value');
				}
			});
		});

		// Start observing the input element for changes to its attributes
		observer.observe(this.profilePhotoInput, { attributes: true });
    }

	loadProfileImage() {
		const image = this.registerProfilePhoto.querySelector(".um-field-area .um-single-image-preview img");
		const imageUrl = this.registerProfilePhoto.dataset.profile_photo;

		const regex = /.*[\\/]([^\/\\]+\.(?:jpe?g|png|gif))(\?|$)/i;
		const matches = imageUrl.match(regex);
		
		if (matches) {
			image.src = imageUrl;
		}

        this.accountSmallAvatar.src = `${this.accountSmallAvatar.src}?ts=${Math.floor(Date.now() / 1000)}`;
	}

	submitChanges() {
		this.accountForm.submit();
	}
}

export default Account;
